export const categories = [
  {
    slug: 'salones-jardines',
    name: 'Salones y Jardines',
    icon: '🏛️',
    description: 'Los mejores foros, jardines, terrazas y salones para celebrar tu fiesta de XV años.',
  },
  {
    slug: 'vestidos-xv',
    name: 'Vestidos de XV Años',
    icon: '👗',
    description: 'Diseñadores, boutiques y renta de vestidos para la quinceañera y su corte de honor.',
  },
  {
    slug: 'academias-baile',
    name: 'Academias de Baile y Vals',
    icon: '💃',
    description: 'Coreografías de vals, baile sorpresa y preparación de chambelanes y damas.',
  },
  {
    slug: 'barras',
    name: 'Barras de Dulces y Bebidas',
    icon: '🍬',
    description: 'Barra de dulces, postres, chocolate, café y bebidas sin alcohol para tus invitados.',
  },
  {
    slug: 'entretenimiento',
    name: 'Entretenimiento y Shows',
    icon: '🎤',
    description: 'DJs, grupos versátiles, mariachi, bandas, shows de luces y animación en vivo.',
  },
  {
    slug: 'maquillaje-peinado',
    name: 'Maquillaje y Peinado',
    icon: '💄',
    description: 'Maquillistas y estilistas profesionales para la quinceañera, mamá y damas.',
  },
  {
    slug: 'limosinas-transporte',
    name: 'Limosinas y Transporte',
    icon: '🚗',
    description: 'Limosinas, autobuses de fiesta y transporte privado para ti y tus invitados.',
  },
  {
    slug: 'cabinas-fotograficas',
    name: 'Cabinas Fotográficas',
    icon: '📸',
    description: 'Cabinas 360°, photobooth, espejo mágico y recuerdos instantáneos.',
  },
  {
    slug: 'fotografia-video',
    name: 'Fotografía y Video',
    icon: '🎥',
    description: 'Fotógrafos y videógrafos especializados en sesiones y cobertura de XV años.',
  },
  {
    slug: 'decoracion-mobiliario',
    name: 'Decoración y Mobiliario',
    icon: '🎈',
    description: 'Decoración temática, globos, iluminación, centros de mesa y mobiliario lounge.',
  },
  {
    slug: 'pasteleria',
    name: 'Pastelería',
    icon: '🎂',
    description: 'Pasteles personalizados, mesas de postres y reposterías de autor.',
  },
  {
    slug: 'invitaciones',
    name: 'Invitaciones y Papelería',
    icon: '💌',
    description: 'Invitaciones impresas y digitales, recuerdos, tarjetería y papelería personalizada.',
  },
];

export const getCategoryBySlug = (slug) => categories.find((c) => c.slug === slug);
